module.exports = function anonymous(locals, filters, escape, rethrow) {
    escape = escape || function(html) {
        return String(html).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&#39;").replace(/"/g, "&quot;");
    };
    var __stack = {
        lineno: 1,
        input: '<div class="course" style="border-right:none">\n    <div class="left_course" style="border-left:4px solid #72685d">\n        <span class="studioname">Plus de cours aujourd\'hui</span>\n        <span class="activityname">A demain</span>\n    </div>\n</div>',
        filename: "."
    };
    function rethrow(err, str, filename, lineno) {
        var lines = str.split("\n"), start = Math.max(lineno - 3, 0), end = Math.min(lines.length, lineno + 3);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    }
    try {
        var buf = [];
        with (locals || {}) {
            (function() {
                buf.push('<div class="course" style="border-right:none">\n    <div class="left_course" style="border-left:4px solid #72685d">\n        <span class="studioname">Plus de cours aujourd\'hui</span>\n        <span class="activityname">A demain</span>\n    </div>\n</div>');
            })();
        }
        return buf.join("");
    } catch (err) {
        rethrow(err, __stack.input, __stack.filename, __stack.lineno);
    }
}


//////////////////
// WEBPACK FOOTER
// /home/app/terminal/release/1715930257-2.1.11/node_modules/ejs-compiled-loader!./src/templates/footer_activities_empty.ejs
// module id = 126
// module chunks = 0